import React, { useState } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import classnames from "classnames";

import { request } from "../../../api";

import ImgIcon from "../../../assets/images/old_vtrg_images/controls/image.png";
import VideoIcon from "../../../assets/images/old_vtrg_images/controls/movie_02.png"; // что?
import ComparisonIcon from "../../../assets/images/old_vtrg_images/controls/before-after.png";

import TextIcon from "../../../assets/images/old_vtrg_images/controls/text.png";
import TwoColumnIcon from "../../../assets/images/old_vtrg_images/controls/2-col-new.png";
import ThreeColumnIcon from "../../../assets/images/old_vtrg_images/controls/3-col.png";

import HTMLIcon from "../../../assets/images/old_vtrg_images/controls/html.png";
import JSONIcon from "../../../assets/images/old_vtrg_images/controls/jsonIcon.svg";

import styles from "./ReorderPopup.module.scss";

  // Types:
  // vtrg_centered_image
  // vtrg_video
  // vtrg_was_became_image
  
  // vtrg_text
  // vtrg_split_screen
  // vtrg_three_columns

  // vtrg_custom_html
  // vtrg_json_img
  
  // vtrg_custom_block
  // vtrg_inner_block

const vtrgIcon = {
  "vtrg_centered_image": ImgIcon,
  "vtrg_video": VideoIcon, "vtrg_custom_block": VideoIcon,
  "vtrg_was_became_image": ComparisonIcon,

  "vtrg_text": TextIcon,
  "vtrg_split_screen": TwoColumnIcon,
  "vtrg_three_columns": ThreeColumnIcon,

  "vtrg_custom_html": HTMLIcon,
  "vtrg_json_img": JSONIcon
};

const scrollTo = (slot) => {
  const target = document.querySelector(`[data-slot="${slot}"]`);

  if (target) {
    target.scrollIntoView({ block: "center", behavior: "smooth" })
  } else {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}
  
const SortableItem = SortableElement(
  ({ type, ordn, imgPreview, preview, slot, comparison }) => {
    const isImgVtrg = type === "vtrg_centered_image";
    const isComparisonVtrg = type === "vtrg_was_became_image";

    const iconClassNames = classnames(styles.Icon, (!isImgVtrg && !isComparisonVtrg) ? styles.IconWithBorder : null);

    return (
      <li className={styles.Item}>
        <div className={styles.ItemNumber}>{ ordn }</div>

        <div className={styles.ItemBody}>
          <div className={styles.PreviewCard}>
            <div className={iconClassNames} onClick={() => { scrollTo(slot) }}>
                { !isImgVtrg && !isComparisonVtrg && <img draggable="false" src={vtrgIcon[type]} alt="" className={styles.VtrgIcon} /> }
                { (isImgVtrg && imgPreview) && <img draggable="false" src={imgPreview} alt="Изображение блока" className={styles.ImagePreview} /> }
                { isComparisonVtrg && <img draggable="false" src={comparison.before} alt={comparison.beforeAlt || "Фото до"} className={styles.ImagePreview} /> }
            </div>

            <div className={styles.ItemPreview}>
              <p className={styles.Text} dangerouslySetInnerHTML={{ __html: isComparisonVtrg ? preview.becameImgName : preview }}></p>
            </div>
          </div>

          {isComparisonVtrg && (
            <div className={styles.PreviewCard}>
              <div className={iconClassNames} onClick={() => { scrollTo(slot) }}>
                  { !isImgVtrg && !isComparisonVtrg && <img src={vtrgIcon[type]} alt="" className={styles.VtrgIcon} /> }
                  { (isImgVtrg && imgPreview) && <img src={imgPreview} alt="Изображение блока" className={styles.ImagePreview} /> }
                  { isComparisonVtrg && <img src={comparison.after} alt={comparison.afterAlt || "Фото после"} className={styles.ImagePreview} /> }
              </div>

              <div className={styles.ItemPreview}>
                <p className={styles.Text} dangerouslySetInnerHTML={{ __html: preview.wasImgName }}></p>
              </div>
            </div>
          )}
        </div>

        <div className={styles.DragIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="23" fill="none" viewBox="0 0 28 23">
            <path stroke="#5d5d6c" strokeLinecap="round" strokeWidth="2" d="M26.92 21.04H1.48m25.44-9.54H1.48m25.44-9.54H1.48"/>
          </svg>
        </div>
      </li>
    );
  }
);

const SortableList = SortableContainer(({ items }) => {
  return (
    <ul className={styles.List}>
      { items.map((item, index) => {
        const generatePreview = (item) => {
          let preview;

          const cutFileName = (str) => {
            const idx = str?.lastIndexOf("/");

            if (!idx) {
              return null;
            }

            const result = str.substring(idx + 1);

            return result;
          };

          switch (item.type) {
            case "vtrg_centered_image": {
              preview = cutFileName(item.params?.image?.url) || "Изображение";
              // item.params?.image?.thumb?.url <- Здесь тумба
              preview = decodeURI(preview);

              break;
            }
            case "vtrg_was_became_image": {
              preview =  {
                becameImgName: decodeURI(cutFileName(item.params?.became_image?.url)) || "Изображение 1", // item.params?.became_image?.thumb?.url
                wasImgName: decodeURI(cutFileName(item.params?.was_image?.url)) || "Изображение 2" // item.params?.was_image?.thumb?.url
              }

              break;
            }
            case "vtrg_custom_block": {
              preview = cutFileName(item.params?.inner?.video?.first_video?.url) || "Видео";
              preview = decodeURI(preview);

              break;
            }
            case "vtrg_text": {
              preview = item.params?.body;
              preview = preview.replace(/(<([^>]+)>)/gi, '');

              break;
            }
            case "vtrg_split_screen": {
              preview = item.params?.lbody || item.params?.rbody || "Два столбца";
              preview = preview.replace(/(<([^>]+)>)/gi, '');

              break;
            }
            case "vtrg_three_columns": {
              preview = item.params?.bodyf || item.params?.bodys || item.params?.bodyt || "Три столбца";
              preview = preview.replace(/(<([^>]+)>)/gi, '');

              break;
            }
            case "vtrg_json_img": {
              preview = "JSON анимация";

              break;
            }
            case "vtrg_custom_html": {
              preview = "HTML блок";

              break;
            }
            default: {
              preview = `${item.ordn}`;
            }
          }

          return preview;
        }

        return (
          <SortableItem
            key={`item-${item.slot}`}
            index={index}
            ordn={item.ordn}
            type={item.type}
            slot={item.slot}
            imgPreview={`${request}${item.params?.image?.thumb?.url}`}
            comparison={{
              after: `${request}${item?.params?.became_image?.thumb?.url}`,
              afterAlt: item?.params?.became_image_alt,
              before: `${request}${item?.params?.was_image?.thumb?.url}`,
              beforeAlt: item?.params?.was_image_alt
            }}
            preview={generatePreview(item)}
          />
        );
      })}
    </ul>
  );
});

const ReorderPopup = ({
  content,
  newContent = [],
  setRetweetWindowShow,
  setHideUpdatePanel,
  setNewOrderRetweet
}) => {
  const [items, setItems] = useState(content.concat(newContent));

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setItems((items) => {
      items = arrayMoveImmutable(items, oldIndex, newIndex);
      if (oldIndex !== newIndex) {
        setNewOrderRetweet(
          items[newIndex].slot,
          items[newIndex + 1] ? items[newIndex + 1].slot : "end",
          items[newIndex].ordn
        );
      }

      return items;
    });
  };

  return (
    <div className={styles.Popup}>
      <header className={styles.Header}>
        <h3 className={styles.Title}>Изменить порядок</h3>

        <button className={styles.CloseButton} onClick={() => {
          setRetweetWindowShow(false);
          setHideUpdatePanel(null);
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26">
            <path stroke="inherit" strokeWidth="2.12" d="M24.96 1.09 1.641 24.409m22.88 0L1.202 1.09"/>
          </svg>
        </button>
      </header>

      <div className={styles.ProjectCover} onClick={() => { scrollTo() }}>
        Обложка проекта
      </div>

      <body className={styles.Body}>
        <SortableList helperClass={styles.ListContainer} useWindowAsScrollContainer={true} lockToContainerEdges={true} items={items} onSortEnd={onSortEnd} lockAxis="y" distance={5}/>
      </body>
    </div>
  );
};

export default ReorderPopup;
